<template lang="pug">
modal#new-developer-client-modal(
  :close='onCloseModal'
  :close-button-label='$t("modal.newDeveloperWebhook.closeButtonLabel")'
  :process-button-label='$t("modal.newDeveloperWebhook.processButtonLabel")'
  :title='$t("modal.newDeveloperWebhook.title")'
  @closed='onCloseModal'
  @process='submit'
  ref='modal'
)
  ValidationObserver(ref='form')
    form.form(@submit.prevent='submit')
      .row
        .col-12
          ValidationProvider(
            :name='$t("modal.newDeveloperWebhook.urlLabel")'
            rules='required|url'
            v-slot='{ errors }'
          )
            .form-group
              label(for='email') {{ $t('modal.newDeveloperWebhook.urlLabel') }}*
              .form-control-icon
                icon(name='globe')
                input#email.form-control(
                  :class='{ "is-invalid": errors.length }'
                  :placeholder='$t("modal.newDeveloperWebhook.urlPlaceholder")'
                  type='text'
                  v-model='url'
                )
              small.text.text-danger {{ errors[0] }}
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';
import WebhookService from '@/services/WebhooksService';
import alert from '@/modules/account/common/alert';
export default {
  name: 'NewDeveloperWebhookModal',
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      name: '',
      url: '',
      public: false,
    };
  },
  methods: {
    onCloseModal() {
      this.name = '';
      this.url = '';
      this.public = false;
      this.$refs.form.reset();
    },
    submit() {
      this.$refs.form.validate().then(async (success) => {
        if (!success) {
          return;
        }
        this.$loading(true);
        const pattern = /^((http|https|ftp):\/\/)/;
        if (!pattern.test(this.url)) {
          this.url = `http://${this.url}`;
        }
        WebhookService.create({
          url: this.url,
        })
          .then(() => {
            this.$refs.modal.close();
            alert.fireAlert(
              this.$t('modal.newDeveloperWebhook.successMessage'),
              {
                classes: 'alert-success',
                styles:
                  'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
                icon: 'circle-check',
              }
            );
            this.$emit('refresh');
            this.$emit('showInfoModal');
          })
          .finally(() => {
            this.$loading(false);
          });
      });
    },
  },
  computed: {},
};
</script>

<style scoped lang="stylus">
#new-developer-webhook-modal
  z-index: 1060;
</style>
